const HAVE_METADATA = 1;


function getFullscreenElement() {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  );
}

function videoElemIsInFullscreen(videoRef) {
  return Boolean(videoRef && videoRef.webkitDisplayingFullscreen);
}

export function isInFullscreen(videoRef) {
  return Boolean(getFullscreenElement()) || videoElemIsInFullscreen(videoRef);
}

export function exitFullscreen(videoRef) {
  if (!isInFullscreen(videoRef)) {
    return;
  }

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }

  // no need to exit from videoRef because it's only possible in ios, which hanles fullscreen button natively
}

export function requestFullscreen(wrapperRef, videoRef) {
  if (isInFullscreen(videoRef)) {
    return;
  }

  if (wrapperRef.requestFullscreen) {
    wrapperRef.requestFullscreen();
  } else if (wrapperRef.msRequestFullscreen) {
    wrapperRef.msRequestFullscreen();
  } else if (wrapperRef.mozRequestFullScreen) {
    wrapperRef.mozRequestFullScreen();
  } else if (wrapperRef.webkitRequestFullscreen) {
    wrapperRef.webkitRequestFullscreen();
  } else if (videoRef && videoRef.webkitEnterFullscreen) {
    // iOS case, call video element directly
    // exitFullScreen should not handle it because on iOS we have native video player for fullScreen

    enterFullScreenOnIOS(videoRef);
  }
}

function enterFullScreenOnIOS(video) {
  try {
    video.webkitEnterFullscreen();
  } catch (e) {
    if (video.readyState < HAVE_METADATA) {
      const enterWhenHasMetaData = () => {
        video.removeEventListener('loadedmetadata', enterWhenHasMetaData);
        video.webkitEnterFullscreen();
      };
      video.addEventListener('loadedmetadata', enterWhenHasMetaData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/fullscreen/utils.js